import React, { memo, useMemo } from "react";
import LightGallery from "lightgallery/react";
import "lightgallery/css/lightgallery.css";
import lgZoom from "lightgallery/plugins/zoom";
import lgVideo from "lightgallery/plugins/video";
import { Trash } from "lucide-react";

const VendorGalleryView = ({ galleryList, handleDelete }) => {
    const renderedGallery = useMemo(() => {
        return (
            <>
                {Array.isArray(galleryList) && galleryList.length > 0 ? (
                    <div className="flex flex-wrap mt-8">
                        {galleryList.map((data, index) => (
                            <div key={index} className="space-y-4 w-full sm:w-[47%] md:w-[31%] lg:w-[32.33%] sm:mr-3 mb-3">
                                <div className="bg-white rounded-2xl p-6 border-gray-200 border shadow-md custom-theme-scroll">
                                    <div className="flex item-center justify-between">
                                        <span className="text-lg mb-4">
                                            <span className="font-extrabold">Image :</span>
                                            <span className="font-medium"> {index + 1} </span>
                                        </span>
                                        {data.id && (
                                            <span onClick={() => handleDelete(data.id)}>
                                                <Trash className="w-4 h-4 cursor-pointer" />
                                            </span>
                                        )}
                                    </div>

                                    <div className="slider-image-wrapper">
                                        <LightGallery
                                            licenseKey={data.id}
                                            plugins={[lgZoom, lgVideo]}
                                            mode="lg-fade"
                                            pager={false}
                                            thumbnail={true}
                                            galleryId={"nature"}
                                            autoplayFirstVideo={false}
                                            elementClassNames={"gallery"}
                                            mobileSettings={{
                                                controls: false,
                                                showCloseIcon: false,
                                                download: false,
                                                rotate: false,
                                            }}
                                        >
                                            <a
                                                data-lg-size="1600-1144"
                                                className="gallery__item"
                                                data-src={data.path}
                                            >
                                                <img
                                                    className="img-responsive slider-image"
                                                    src={data.path}
                                                    alt={`Gallery Item ${index + 1}`}
                                                />
                                            </a>
                                        </LightGallery>
                                    </div>

                                    <div className="slider-image-detail pt-2.5 px-2.5 items-baseline">
                                        <div className="text-justify leading-5">
                                            <span className="font-bold text-lg mr-2">Data:</span>
                                            <span className="text-sm font-medium">{data.description}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : <p> no image</p>}
                
            </>
        );
    }, [galleryList]);

    return renderedGallery;
};

export default memo(VendorGalleryView);